import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-faq-rules-of-procedure',
  templateUrl: './faq-rules-of-procedure.component.html',
  styleUrls: ['./faq-rules-of-procedure.component.css']
})
export class FaqRulesOfProcedureComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
